import loadable from '@loadable/component'

export const ApplicableCriteria = loadable(() => import('./ApplicableCriteria'))
// export default ApplicableCriteria
export type { ApplicableCriteriaProps } from './ApplicableCriteria'
